import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = /*#__PURE__*/function () {
  function t(_t, s, d, h) {
    _classCallCheck(this, t);

    this.helper = _t, this.dx = s, this.dy = d, this.dz = h;
  }

  _createClass(t, [{
    key: "move",
    value: function move(_t2, s, d, h) {
      this.helper.addDelta(_t2.pos, s, d, h);
    }
  }, {
    key: "apply",
    value: function apply(_t3) {
      this.move(_t3, this.dx, this.dy, this.dz);
    }
  }, {
    key: "undo",
    value: function undo(_t4) {
      this.move(_t4, -this.dx, -this.dy, -this.dz);
    }
  }, {
    key: "canAccumulate",
    value: function canAccumulate(s) {
      return s instanceof t;
    }
  }, {
    key: "accumulate",
    value: function accumulate(_t5, s) {
      this.move(_t5, s.dx, s.dy, s.dz);
    }
  }, {
    key: "accumulateParams",
    value: function accumulateParams(_t6) {
      this.dx += _t6.dx, this.dy += _t6.dy, this.dz += _t6.dz;
    }
  }]);

  return t;
}();

export { t as MoveVertex };